import { shopCartFragment$data } from '__generated__/shopCartFragment.graphql';
import { PROMO_CATEGORIES } from '../constants';

const getShippableOfferIds = (
  shippableItems: shopCartFragment$data['shippableItems'],
): string[] =>
  shippableItems
    ?.filter(
      (item) =>
        !PROMO_CATEGORIES.some((category) =>
          item?.categories?.includes(category),
        ),
    )
    .map((item) => item.offerId) ?? [];
export default getShippableOfferIds;
